/*
 *  Document   : consultant-companies.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class ConsultantCompaniesEdit {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantCompaniesEdit"] = this;
        this.init();
    }

    init() {
        $('#company-users .js-dataTable-full-pagination').DataTable({
            ajax: jsVars.datatablesAjax,
            order: [[1, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {data: "id"},
                {
                    data: 'first_name',
                    render: function (data, type, row) {
                        return `<a href="${jsVars.clientEditUrl.replace(':user-id', row.id)}" class="empty-link btn btn-ghost text-primary table">${row.first_name} ${row.last_name}</a>`;
                    }
                },
                {data: "email"},
                {data: "phone_number"},
                {data: "mobile_number"},
            ],
            drawCallback: function () {
                if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden')
            },
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

        this.initRatingsTabConsultant();

        ExaHelpers.validation();
        this.initValidation();
    }

    initRatingsTabConsultant() {


        this.ratingsTable = this.ratingsTable || $('#company-rating-consultant .js-dataTable-full-pagination').DataTable({
            ajax: jsVars.datatablesRatingAjax,
            order: [[4, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "submitter_id",
                    render: function (data, type, row) {
                        //return `${data ?? ""}`;
                        return `<a href="${jsVars.clientEditUrl.replace(':user-id', row.submitter_id)}" class="empty-link btn btn-ghost text-primary table company-user-link">${row.submitter.first_name} ${row.submitter.last_name}</a>`;
                    }
                },
                {
                    data: "mission_id",
                    render: function (data, type, row) {
                        //return `${data ?? ""}`;
                        let html = `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.mission_id)}">${row.mission.titre ?? row.mission.professions}</a>`;
                        return html;
                    }
                },
                {
                    data: "clarity_of_instructions_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "allocated_time_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "atmosphere_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "comment",
                    render: function (data, type, row) {
                        //return `${ExaHelpers.ratingToIcons(data)}`;
                        return (data == null)? "" : `${data ?? ""}`;
                    }
                },
                {
                    data: "updated_at",
                    render: function (data, type, row) {
                        return (data == null)? '' : ExaHelpers.formatDateTimeWithLocale(new Date(data), jsVars.labelBetween);
                    }
                },
                {
                    data: "id",
                    render: function (data, type, row) {

                        return `
                        <form onclick="return confirm('${jsVars.deleteThisEvaluationSure}')" method="POST" action="${jsVars.deleteRatingUrl.replace(':rating-id', data)}">
                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                            <button type="submit" class="btn btn-sm btn-outline-danger btn-small js-swal-confirm">${jsVars.deleteThisEvaluation}</button>
                        </form>
                        `;


                   }
                },
            ],
            drawCallback: function () {
                if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden')
            },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

    }


    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'chid': {
                    required: true,
                },
                'address_line_1': {
                    required: true,
                },
                'postcode': {
                    required: true,
                },
                'city': {
                    required: true,
                },
                'country_id': {
                    required: true,
                },
                'phone_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'branch_id': {
                    required: true,
                },
            },
        });

        // Init Validation on Select2 change
        $('.js-select2:not(.skip-validation)').on('change', e => {
            $(e.currentTarget).valid();
        });
    }

    showUser(id, userName) {
        alert('Not implemented yet. Opens Clients->edit client view');
    }
}
